import React, { useState } from 'react';
import ReactDOM from 'react-dom';

import { TooltipProps } from './types';

import { Container, Hoverable } from './components/styled';
import { TooltipPopover } from './components/TooltipPopover';

export const Tooltip = ({
  children,
  text,
  content,
  config,
  reversed = false,
  className,
  withTriangle,
  initialShouldShow = false,
  useReactPortal = true,
}: TooltipProps): JSX.Element | null => {
  const [shouldShow, setShouldShow] = useState(initialShouldShow);
  const [hoverableElement, setHoverableElement] = useState<HTMLDivElement | null>(null);

  const hasText = text ? text.trim().length > 0 : false;

  const classNames = {
    container: className && `${className} ${className}-container`,
    tip: className && `${className}-tip`,
    wrap: className && `${className}-wrap`,
    triangle: className && `${className}-triangle`,
    hoverable: className && `${className}-hoverable`,
  };

  const hasContent = !!(content || hasText);
  if (!hasContent) return children;

  const show = () => setShouldShow(true);
  const hide = () => setShouldShow(false);

  const tooltipMarkup = shouldShow && hasContent && (
    <TooltipPopover
      classNames={classNames}
      hoverableElement={hoverableElement}
      config={config}
      reversed={reversed}
      withTriangle={withTriangle}
      text={text}
      content={content}
    />
  );

  return (
    <Container className={classNames.container}>
      {useReactPortal ? ReactDOM.createPortal(tooltipMarkup, document.body) : tooltipMarkup}
      <Hoverable
        ref={setHoverableElement}
        className={classNames.hoverable}
        onMouseEnter={show}
        onMouseLeave={hide}
      >
        {children}
      </Hoverable>
    </Container>
  );
};
